export default __webpack_public_path__ + "static/media/dreamstime_s_37910249.c7634457.jpg";